import { render, staticRenderFns } from "./OpeningClosing.vue?vue&type=template&id=3a0b3d44&scoped=true&"
import script from "./OpeningClosing.vue?vue&type=script&lang=js&"
export * from "./OpeningClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b3d44",
  null
  
)

export default component.exports